var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        _vm._l(_vm.perguntas, function(pergunta) {
          return _c(
            "el-collapse-item",
            {
              key: pergunta.numero,
              attrs: { name: pergunta.numero, title: pergunta.pergunta }
            },
            [_c("p", [_vm._v(_vm._s(pergunta.resposta))])]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c5b48d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c5b48d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/informacao/PerguntasFrequentes.vue
// module id = null
// module chunks = 